import SaveAltIcon from "@mui/icons-material/SaveAlt";
import { Button, CircularProgress } from "@mui/material";
import { GridToolbarContainer } from "@mui/x-data-grid";
import { useTranslation } from "react-i18next";

declare module "@mui/x-data-grid" {
  interface ToolbarPropsOverrides {
    totalCount: number;
    isExporting: boolean;
    progress: number;
    onExport: () => void;
  }
}

interface PatientListExportAllToolbarProps {
  totalCount: number;
  isExporting: boolean;
  progress: number;
  onExport: () => void;
}

export const PatientListExportAllToolbar: React.FC<PatientListExportAllToolbarProps> = ({
  totalCount,
  isExporting,
  progress,
  onExport,
}) => {
  const { t } = useTranslation();

  const disabled = isExporting || totalCount <= 0;
  const label = isExporting
    ? t("partner_patients.exporting_progress", { current: progress, total: totalCount })
    : t("buttons.export");

  return (
    <GridToolbarContainer sx={{ justifyContent: "flex-end" }}>
      <Button
        size="small"
        startIcon={isExporting ? <CircularProgress size={16} color="primary" /> : <SaveAltIcon />}
        onClick={onExport}
        disabled={disabled}
      >
        {label}
      </Button>
    </GridToolbarContainer>
  );
};
